// @ts-strict-ignore
import { useEffect, useState } from "react";

import { InputRadio } from "components/ui/input/InputRadio";
import { InputRowInline } from "components/ui/input/InputRowInline";
import { Button } from "components/ui-deprecated/Button";
import { Dialog } from "components/ui-deprecated/Dialog";
import { useAppSelector } from "store";
import { Units } from "store/slices/user.slice";

type Props = {
    initialValue: string | null;
    onSubmit: (unit: string) => Promise<void>;
    onCancel: () => void;
};

function UnitSettingsModal(props: Props) {
    const { initialValue } = props;
    const userId = useAppSelector((state) => state.user.id);

    const [selectedUnit, setSelectedUnit] = useState<string | null>(initialValue);

    const handleSubmit = () => {
        props.onSubmit(selectedUnit);
    };

    useEffect(() => {
        setSelectedUnit(initialValue);
    }, [initialValue]);

    return (
        <>
            <Dialog.Content.Body>
                {Object.keys(Units).map((unit) => (
                    <InputRowInline key={unit}>
                        <InputRadio
                            id={unit}
                            name={"unit"}
                            value={unit}
                            checked={unit === selectedUnit}
                            onChange={(e) => {
                                setSelectedUnit(Units[e.target.value]);
                            }}
                        />
                        <label htmlFor={unit}>{unit}</label>
                    </InputRowInline>
                ))}
            </Dialog.Content.Body>
            <Dialog.Content.Actions>
                <Button variant={"text"} onClick={props.onCancel}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} disabled={userId === null}>
                    Submit
                </Button>
            </Dialog.Content.Actions>
        </>
    );
}

export { UnitSettingsModal };
